import { useRef, useEffect, useState } from "react";
import GetIcon from "../../../../../utils/Icon";
import Button from "../../../../../Core/Button/Button";
import Pagination from "../../../../../Components/Pagination";
import { handleDownloadCSV } from "../../../../../utils/CsvDownload";
import useKeyboardNavigation from "../../../../../utils/useKeyboardNavigation";
import { formatIndianPriceWithComa } from "../../../../../utils/formatIndianPrice2";

const TaxAndChargesTable = ({ setselected_item_data, list_data, po_status, setRows, rows,row_list,apidata,totalPriceWithTax }) => {
  const itemRefs = useRef([]); 
  const createNewRow = () => ({
    item_code: "",
    item: {},
    required_by: "",
    quantity: 1,
    uom: "",
    rate: "0",
    amount: "0",
  });

  const tableRef = useRef();
  const dropdownRef = useRef();
  const [rowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [item_list, setitem_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => [...new Set([...prev, ...pageRowIndices])]);
    } else {
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => prev.filter((i) => !pageRowIndices.includes(i)));
    }
  };

  const { focusedCellkey, setFocusedCellkey } = useKeyboardNavigation(rows.length);
  
  const getItemdata = async (newOffset = 0, searchText = "") => {
    const res = await list_data({ start: newOffset, search_input: searchText, disabled: 0,productlist:rows.map(d => d.item.item_code) });
    const products = res?.data?.result?.products || [];
    if (newOffset === 0) {
      setitem_list(products);
    } else {
      setitem_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 20);
  };




const updateRow = (index, field, value) => {

  let updatedRow;
  if (field === "item") {
    updatedRow = {
      ...rows[index],
      item: value,
      item_code: value.item_code,
      rate: value.buying_price || rows[index].rate,
    };
  } else {
    updatedRow = { ...rows[index], [field]: value };
  }

  const quantity = parseFloat(updatedRow.quantity) || 0;
  const rate = parseFloat(updatedRow.rate) || 0;
  updatedRow.amount = (quantity * rate).toFixed(2);

  const updatedRows = [...rows];
  updatedRows[index] = updatedRow;


  setRows(updatedRows);
  setselected_item_data(updatedRows);
  // list_data({ start: 0, search_input: '', disabled: 0,productlist:updatedRows.map(d => d.item_code) })
};



  const toggleRowSelection = (index) => {
    setSelectedRows((prev) => prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]);
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows([]);
    setRows(updatedRows);
    setselected_item_data([]);
    setselected_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    getItemdata(0, "");
  }, []);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;
    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getItemdata(newOffset, search_input);
      }
    };
    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);



  return (
    <div className="px-2" style={{border:'1px solid #DBDBDB',borderRadius:'4px'}}>
      <div className="py-2  d-flex justify-content-between">
        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Taxes and Charges</p>
        <div className="buttondiv d-flex " style={{gap:'5px' }}>
               {/* <p className="NoOfLine">Total Quantity - <span style={{ color: '#16A34A' }}> {0}</span></p>
               <p className="TotalQtyNew">Total (INR) - <span style={{ color: '#da144e' }}>₹{0}</span></p> */}
              
        </div>
      </div>
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["Action", "Sl.No" ,"Tax Category" , "Sales Taxes and Charges Template", "Type", "Account Head", "Tax Rate","Amount (INR)","Total (INR)","After Discount Amount","Setting"].map((title, i) => {
              const defaultWidths = {
                "Action": "4%",
                "Sl.No": "4%",
                "Tax Category": "11%",
                "Sales Taxes and Charges Template": "15%",
                "Type": "8%",
                "Account Head": "9%",
                "Tax Rate":"9%",
                "Amount (INR)": "7%",
                "Total (INR)": "6%",
                "After Discount Amount": "12%",
                "Setting": "5%",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: title === "Action" || title === "S.No" ? "center" : "center",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Action" && (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ backgroundColor: isAllSelected ? "#270b79" : "", borderColor: isAllSelected ? "#270b79" : "", fontSize: '15px' }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  )}

                  {title === "Setting" && (
                     <div className="d-flex justify-content-center" style={{position:'relative',top:'-3px'}}>
                       <GetIcon iconName="VscSettings" size={13} />
                     </div>
                  )}

                  {title == "Action" || title == "Setting" ? '' : (title)}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {row_list.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            
            return (
              <tr key={globalIndex} style={{ height: '30px' }}>
                <td className="p-0" style={{ cursor: 'pointer' }}>
                  <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79' }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                      </span>
                    )}
                  </p>
                </td>
                <td className="p-0" style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  lineHeight: '29px'
                }}>
                  {globalIndex + 1}
                </td>
                
                {/* Item Name */}
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.tax_category || ""} />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.taxes_and_charges || ""} />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.charge_type || ""} />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.account_head || ""} />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.rate} />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={formatIndianPriceWithComa(row?.amount || 0)} />
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={formatIndianPriceWithComa((row?.runningTotal + (parseFloat(totalPriceWithTax))).toFixed(2))} />
                
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={formatIndianPriceWithComa(row?.amount || 0)} />
                </td>
                <td className="p-0" >
                                  <span
                                    // onClick={() => openEditModal(row, globalIndex)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <GetIcon iconName="MdOutlineEdit" size={15} />
                                  </span>
                                </td>
                             
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {selectedRows.length > 0 && po_status == '' && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length == 0 && po_status == '' && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{ backgroundColor: '#F6D593', padding: '1px', display: 'flex' }}
            >
              Add Row
            </Button>
          )}
           <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
            onClick={() => {
              handleDownloadCSV([
                  "S.No",
                  "Item Code (Items)",
                  "Item Name (Items)",
                  "Category",
                  "Sub Category",
                  "Quantity (Items)",
                  "Rate (Items)",
                  "UOM (Items)",
                "Amount"]
                , rows,
              "purchase_order")
            }}
          >
            Download
          </Button>

        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>

      </div>
    </div>
  );
};

export default TaxAndChargesTable;